





















































































import { Component, Vue, Prop } from 'vue-property-decorator';
import DossierApi from '@/store/api/DossierApi';
import UploadServiceApi from '@/store/api/UploadServiceApi';
import IBlob from '@/store/models/IBlob';
import Snackbar from '@/components/shared/Snackbar.vue';

@Component({ components: { Snackbar } })
export default class DossierOutboundsPictures extends Vue {
  @Prop({ type: String, required: true }) inboundCode!: string;
  @Prop({ type: String, required: true }) idCompany!: string;

  dossierApi = new DossierApi();
  uploadServiceApi = new UploadServiceApi('Dossiers');

  pictures: any[] = [];
  blobPictures: IBlob[] = [];
  loadingPictures = false;

  async mounted() {
      await this.loadOutboundPictures();
  }

  /** 🔹 Carga lista de imágenes desde API y genera blobUrls */
  async loadOutboundPictures() {
      if (!this.inboundCode) return;
      this.loadingPictures = true;
      this.pictures = [];
      this.blobPictures = [];

      try {
          const data = await this.dossierApi.DossierReadOutboundsPictures(this.inboundCode);
          this.pictures = data;

          const blobPromises = this.pictures.map(async (pic) => {
              const blobUrl = await this.uploadServiceApi.DownloadPictures(pic.url);
              return {
                  id: pic.id,
                  url: pic.url,
                  blobUrl,
                  outboundId: this.inboundCode
              } as IBlob;
          });

          this.blobPictures = await Promise.all(blobPromises);
      } catch (err) {
          console.error('❌ Error loading outbound pictures:', err);
      } finally {
          this.loadingPictures = false;
      }
  }
}
